import { render } from "./MdForgotPass.vue?vue&type=template&id=c5328624"
import script from "./MdForgotPass.vue?vue&type=script&lang=js"
export * from "./MdForgotPass.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__